import React from 'react';
import { Navigate } from 'react-router-dom';

interface ServiceRouteProps {
  children: React.ReactElement;
}

const ServiceRoute: React.FC<ServiceRouteProps> = ({ children }) => {
  // Check for either platform token OR service token
  const platformToken = localStorage.getItem('access_token');
  const serviceToken = localStorage.getItem('serviceToken');
  
  // If neither token exists, redirect to services portal for authentication
  if (!platformToken && !serviceToken) {
    // Use Navigate instead of window.location to preserve SPA behavior
    return <Navigate to="/app/services" replace />;
  }

  return children;
};

export default ServiceRoute;